import React from 'react';
import styled from 'styled-components';
import {words} from '../translations'

const ProgressBar = ({ currentQuestion, totalQuestions, quesId,language,color,color2 }) => {
  const progressPercentage = (currentQuestion / totalQuestions) * 100;
  const isLocalhost = window.location.hostname === 'localhost';

  return (
    <ProgressBarContainer color2={color2}>
      <ProgressText>
        {/* <span style={{ color: '#2A3039', fontWeight: 600 }}>{currentQuestion}</span> {words['of'][language]} {totalQuestions} */}
      </ProgressText>
      <FilledBar style={{ width: `${progressPercentage}%` }} color={color} />
    </ProgressBarContainer>
  );
};

export default ProgressBar;

const ProgressBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: ${props=>props.color2?props.color2:'#D5E2F9'};
  display: flex;
  align-items: center;
  border-radius: 0;
  z-index: 1001;
`;

const FilledBar = styled.div`
  height: 100%;
  background-color: ${props=>props.color?props.color:'#2D70E2'};
  transition: width 300ms;
  border-radius: 20px;
`;

const ProgressText = styled.div`
  display:none;
`;